import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input, Spinner } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MdDone, MdWarning, MdCancel, MdEmail, MdCameraAlt } from 'react-icons/md'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import { CSVLink } from 'react-csv'
import Select from 'react-select'

const tbcolumn = [
  {
    label: 'Invoice No.',
    field: 'invoice_no',
    sort: 'asc',
  },
  {
    label: 'Customer',
    field: 'customer',
    sort: 'asc',
  },
  {
    label: 'Invoice Date',
    field: 'invoice_date',
    sort: 'asc',
  },
  {
    label: 'Due Date',
    field: 'due_date',
    sort: 'asc',
  },
  {
    label: 'Terms',
    field: 'terms',
    sort: 'asc',
  },
  {
    label: 'Location',
    field: 'location',
    sort: 'asc',
  },
  {
    label: 'Schedule',
    field: 'schedule',
    sort: 'asc',
  },
  {
    label: 'Memo',
    field: 'memo',
    sort: 'asc',
  },
  {
    label: 'Item(Product/Service)',
    field: 'item',
    sort: 'asc',
  },
  {
    label: 'Item(Description)',
    field: 'item_description',
    sort: 'asc',
  },
  {
    label: 'Item(Quantity)',
    field: 'item_quantity',
    sort: 'asc',
  },
  {
    label: 'Item(Rate)',
    field: 'item_rate',
    sort: 'asc',
  },
  {
    label: 'Item(Amount)',
    field: 'item_amount',
    sort: 'asc',
  },
  {
    label: 'Item(TaxCode)',
    field: 'item_taxcode',
    sort: 'asc',
  },
  {
    label: 'Item(TaxAmount)',
    field: 'item_taxamount',
    sort: 'asc',
  },
  {
    label: 'Currency',
    field: 'currency',
    sort: 'asc',
  },
  {
    label: 'Service Date',
    field: 'service_date',
    sort: 'asc',
  },
]

const headers = [
  {
    label: '*Invoice No.',
    key: 'invoice_no',
  },
  {
    label: '*Customer',
    key: 'customer',
  },
  {
    label: '*Invoice Date',
    key: 'invoice_date',
  },
  {
    label: '*Due Date',
    key: 'due_date',
  },
  {
    label: 'Terms',
    key: 'terms',
  },
  {
    label: 'Location',
    key: 'location',
  },
  {
    label: 'Schedule',
    key: 'schedule',
  },
  {
    label: 'Memo',
    key: 'memo',
  },
  {
    label: 'Item(Product/Service)',
    key: 'item',
  },
  {
    label: 'Item(Description)',
    key: 'item_description',
  },
  {
    label: 'Item(Quantity)',
    key: 'item_quantity',
  },
  {
    label: 'Item(Rate)',
    key: 'item_rate',
  },
  {
    label: '*Item(Amount)',
    key: 'item_amount',
  },
  {
    label: '*Item(TaxCode)',
    key: 'item_taxcode',
  },
  {
    label: 'Item(TaxAmount)',
    key: 'item_taxamount',
  },
  {
    label: 'Currency',
    key: 'currency',
  },
  {
    label: 'Service Date',
    key: 'service_date',
  },
]

const tes_headers = [
  {
    label:"Store Code",
    key:"store_code"
  },
  {
    label:"Order ID",
    key:"order_id"
  },
  {
    label:"Order Date",
    key:"order_date"
  },
  {
    label:"Status",
    key:"order_status"
  },
  {
    label:"Payment",
    key:"payment_status"
  },
  {
    label:"Category",
    key:"category"
  },
  {
    label:"Product No",
    key:"product_no"
  },
  {
    label:"Name",
    key:"name"
  },
  {
    label:"Quantity",
    key:"qty"
  },
  {
    label:"Unit Price",
    key:"unitprice"
  },
  {
    label:"Price",
    key:"price"
  },
  {
    label:"Schedule Date",
    key:"schedule_date"
  },
  {
    label:"Customer",
    key:"customer"
  },
  {
    label:"Contact",
    key:"contact"
  },
  {
    label:"Address",
    key:"address"
  },
  {
    label:"Postal Code",
    key:"postal_code"
  },
  {
    label:"Billing Contact",
    key:"billing_contact"
  },
  {
    label:"Order Message",
    key:"order_msg"
  },
  {
    label:"Remarks",
    key:"remark"
  },
]

const headers2 = [
  {
      key: "*InvoiceNo",
      label: "*InvoiceNo"
  },
  {
      key: "*Customer",
      label: "*Customer"
  },
  {
    key: "CustomerName",
    label: "CustomerName"
  },
  {
      key: "*InvoiceDate",
      label: "*InvoiceDate"
  },
  {
      key: "*DueDate",
      label: "*DueDate"
  },
  {
      key: "Terms",
      label: "Terms"
  },
  {
      key: "Location",
      label: "Location"
  },
  {
      key: "Memo",
      label: "Memo"
  },
  {
      key: "Item(Product/Service)",
      label: "Item(Product/Service)"
  },
  {
      key: "ItemDescription",
      label: "ItemDescription"
  },
  {
      key: "ItemQuantity",
      label: "ItemQuantity"
  },
  {
      key: "ItemRate",
      label: "ItemRate"
  },
  {
      key: "*ItemAmount",
      label: "*ItemAmount"
  },
  {
      key: "*ItemTaxCode",
      label: "*ItemTaxCode"
  },
  {
      key: "ItemTaxAmount",
      label: "ItemTaxAmount"
  },
  {
      key: "Remarks",
      label: "Remarks"
  }
]

class MlbExport extends React.Component {
  _isMounted = true
  MlbExport = StorageService.getSession('MlbExport')
  comp = StorageService.getSession('selected_org')
  constructor(props) {
    super(props)
    this.state = {
      //isLoading: true,
      filterList: [],
      fm_date: this.MlbExport && this.MlbExport.fm_date ? this.MlbExport.fm_date : moment().startOf('month').tz('Asia/Singapore').format('YYYY-MM-DD'),
      to_date: this.MlbExport && this.MlbExport.to_date ? this.MlbExport.to_date : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      csvInvoice: [],
      csvPrepaid: [],
      csvFOC: [],
      storeList: [],
      store_id: this.MlbExport && this.MlbExport.store_id ? this.MlbExport.store_id : '25',
      Role: this.comp.Role,
      headers: [],
      userList: [],
      user_id: '',
      outlet_order: [],
      sales_report: [],
      paid_only: 1,
      f_store_id:this.MlbExport && this.MlbExport.f_store_id ? this.MlbExport.f_store_id : '25',
      f_fm_date: this.MlbExport && this.MlbExport.f_fm_date ? this.MlbExport.f_fm_date : moment().startOf('month').tz('Asia/Singapore').format('YYYY-MM-DD'),
      f_to_date: this.MlbExport && this.MlbExport.f_to_date ? this.MlbExport.f_to_date : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      fcsvInvoice: []

    }

    this.csvLinkEl = React.createRef()
    this.csvLinkEl2 = React.createRef()
  }

  componentDidMount() {
    this.getStoreList()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getStoreList() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        console.log(result);
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          console.log("ismounted")
          let storeList = []
          for (let i of access.store) {
            for (let j of result.data) {
              if (j.store_id === i.store_id) {
                if (i.role == 'Admin' || i.role == 'Supervisor' || i.role == 'Financial' || i.role == 'Manager' || i.role == 'Superuser') {
                  storeList.push(j)
                }
              }
            }
          }
          console.log(storeList);
          this.setState({
            storeList: storeList,
          })
        }else{
          console.log("isnotmounted")
        }
      })
      .catch(error => {
        console.log(error)
        alert(error)
      })
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
    let data = this.MlbExport ? this.MlbExport : {}
    data[name] = value
    StorageService.setSession('MlbExport', data)
    this.MlbExport = StorageService.getSession('MlbExport')
  }

  storeHandler = e => {
    const { label, value } = e
    this.setState({
      store_id: value,
    })
    let data = this.MlbExport ? this.MlbExport : {}
    data['store_id'] = value
    StorageService.setSession('MlbExport', data)
    this.MlbExport = StorageService.getSession('MlbExport')
  }

  storeHandler2 = e => {
    const { label, value } = e
    //console.log(value);
    this.setState({
      f_store_id: value,
    })
    let data = this.MlbExport ? this.MlbExport : {}
    data['f_store_id'] = value
    StorageService.setSession('MlbExport', data)
    this.MlbExport = StorageService.getSession('MlbExport')
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.MlbExport ? this.MlbExport : {}
    data[name] = value
    StorageService.setSession('MlbExport', data)
    //this.getOrder(value)
  }

  searchHandler = e => {
    console.log(e.target)
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })

    let data = this.MlbExport ? this.MlbExport : {}
    data[name] = value
    StorageService.setSession('MlbExport', data)
    this.MlbExport = StorageService.getSession('MlbExport')
  }

  dateHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })

    let data = this.MlbExport ? this.MlbExport : {}
    data[name] = value
    StorageService.setSession('MlbExport', data)
    this.MlbExport = StorageService.getSession('MlbExport')
  }

  CsvInvoice = async () => {
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      company_id: comp.CompanyID,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
      paid_only: this.state.paid_only,
    }

    axios
      .post(url + ':3003/v2/order/export/custom/mlb/sales', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.invoice_date) {
              i.invoice_date = moment(i.invoice_date).tz('Asia/Singapore').format('DD/MM/YYYY')
            }
          }

          if (result.data.length > 0) {
            let headers = [
              ...Object.keys(result.data[0])
                .reduce((r, o) => {
                  let key = o
                  let item = { key: o, label: o }
                  return r.set(key, item)
                }, new Map())
                .values(),
            ]
            console.log(headers);

            this.setState(
              {
                csvInvoice: result.data,
                isLoading: false,
                headers: headers,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound('No Sales Order')
          }
        }
      })
      .catch(error => {
        alert(error)
        this.setState({
          isLoading: false,
        })
      })
  }

  CsvNotFound(message) {
    this.setState({ isLoading: false })
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: message,
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  CsvInvoice2 = async () => {
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.f_store_id,
      company_id: comp.CompanyID,
      fm_date: this.state.f_fm_date,
      to_date: this.state.f_to_date,
      search_type:"Fulfilment",
      showservice:"0",
      sortcustomer:"1"
    }

    axios
      .post(url + ':3003/v1/order/export/custom/mlb/orders', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.invoice_date) {
              i.invoice_date = moment(i.invoice_date).tz('Asia/Singapore').format('DD/MM/YYYY')
            }
          }

          console.log(result);

          if (result.data.length > 0) {
            let headers = [
              ...Object.keys(result.data[0])
                .reduce((r, o) => {
                  let key = o
                  let item = { key: o, label: o }
                  return r.set(key, item)
                }, new Map())
                .values(),
            ]

            this.setState(
              {
                fcsvInvoice: result.data,
                isLoading: false,
                headers: headers,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl2.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound('No Sales Order')
          }
        }
      })
      .catch(error => {
        alert(error)
        this.setState({
          isLoading: false,
        })
      })
  }

  render() {
    const data = {
      columns: tbcolumn,
      rows: this.state.filterList,
    }

    let options = [
      ...this.state.storeList
        .reduce((r, o) => {
          let key = o.store_id
          let item = { value: o.store_id, label: o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]

    options.unshift({ value: '0', label: 'All' })

    let options2 = [
      ...this.state.storeList
        .reduce((r, o) => {
          let key = o.store_id
          let item = { value: o.store_id, label: o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]
    

    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <Form>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Sales Order</p>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Store</Label>
              <Select options={options} value={options.filter(i => i.value == this.state.store_id)} name="store_id" onChange={this.storeHandler} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Invoice Date (Fm)</Label>
                <Input className="ps-input-small" type="date" name="fm_date" value={this.state.fm_date} onChange={this.dateHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Invoice Date (To)</Label>
                <Input className="ps-input-small" type="date" name="to_date" value={this.state.to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label>Paid Only</Label>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" name="paid_only" checked={this.state.paid_only} onChange={this.checkHandler} />
                </Label>
              </FormGroup>
            </Col>
            <Col
              md={2}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.isLoading} onClick={this.CsvInvoice}>
                Export
              </Button>
              <CSVLink headers={headers2} filename={'sales_report_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.csvInvoice} ref={this.csvLinkEl} />
            </Col>
          </Row>
        </Form>

        <Form>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Fulfillment Orders (Merge Set)</p>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Store</Label>
              <Select options={options2} value={options2.filter(i => i.value == this.state.f_store_id)} name="f_store_id" onChange={this.storeHandler2} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Invoice Date (Fm)</Label>
                <Input className="ps-input-small" type="date" name="f_fm_date" value={this.state.f_fm_date} onChange={this.dateHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Invoice Date (To)</Label>
                <Input className="ps-input-small" type="date" name="f_to_date" value={this.state.f_to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            {/* <Col md={2}>
              <Label>Paid Only</Label>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" name="paid_only" checked={this.state.paid_only} onChange={this.checkHandler} />
                </Label>
              </FormGroup>
            </Col> */}
            <Col
              md={2}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.isLoading} onClick={this.CsvInvoice2}>
                Export
              </Button>
              <CSVLink headers={tes_headers} filename={'fulfillment_orders_' + moment(this.state.f_fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.f_to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.fcsvInvoice} ref={this.csvLinkEl2} />
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export default MlbExport
